import styled from 'styled-components';

export const Switch = styled.div`
  .switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--border-primary);
    -webkit-transition: var(--transition-slow);
    transition: var(--transition-slow);
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 14px;
    width: 14px;
    top: 3px;
    left: 3px;
    background-color: var(--background-secondary);
    -webkit-transition: var(--transition-slow);
    transition: var(--transition-slow);
  }

  input:checked + .slider {
    background: var(--brand-primary);
  }

  input:checked + .slider:before {
    transform: translateX(20px);
    background-color: var(--text-white);
  }

  .slider.round {
    border-radius: var(--border-radius-full);
  }

  .slider.round:before {
    border-radius: var(--border-radius-full);
  }
`;
